import db from '../../config/databases/referential';

export default async function getLocalReferential(referentialId, refUpdateDate = null) {
  const referential = await db.referential.get(referentialId);
  if (
    referential === undefined ||
    !Object.prototype.hasOwnProperty.call(referential, 'referential') ||
    (refUpdateDate !== null && refUpdateDate.updated !== referential.updated)
  )
    throw new Error('referential_missing');
  return referential.referential;
}
